import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import HeaderLogoIcon from "../../components/headerLogoIcons/headerLogoIcons";
import FooterHomePage from "../../components/footerHomePage/footerHomePage";
import UpdatepersonalInformation from "../../components/SeccionFormUpdateUser/UpdatePersonalInformation";
import UpdateeconomicInformation from "../../components/SeccionFormUpdateUser/UpdateEconomicInformation";
import UpdateemployerInformation from "../../components/SeccionFormUpdateUser/UpdateEmployerInformation";
import UpdaterelationshipWithMutual from "../../components/SeccionFormUpdateUser/UpdateRelationshipWithMutual";
import UpdatepoliticAndTerroris from "../../components/SeccionFormUpdateUser/UpdatePolitical";
/*-------------------------*/
import CompanyInformation from "../../components/SeccionFormUpdateCompany/UpdateCompanyInformation";
import CompanyEconomicInformation from "../../components/SeccionFormUpdateCompany/EconomicInformationCompany";
import CompanyRelationMutual from "../../components/SeccionFormUpdateCompany/RelationshipMutualCompany";
import CompanyTerrorism from "../../components/SeccionFormUpdateCompany/PoliticAndTerrorismCompany";
import UpdateLoader from "../../components/UpdateLoader/UpdateLoader";
import "./FormUpdateManual.css";
import moment from "moment";

const FormUpdateManual = () => {
  const data = useLocation();
  const navigate = useNavigate();
  const [LoaderTrueFalse, setLoaderTrueFalse] = useState(false);
  const [showButton, setShowButton] = useState(true);
  //Persona Humana
  const nameRef = useRef(null);
  const lastNameRef = useRef(null);
  const documentTypeRef = useRef(null);
  const civilStatusRef = useRef(null);
  const nationalityRef = useRef(null);
  const dniRef = useRef(null);
  const cuilRef = useRef(null);
  const dateOfBirthRef = useRef(null);
  const placeOfBirthRef = useRef(null);
  const phoneHumanRef = useRef(null);
  const emailHumanRef = useRef(null);
  const street = useRef(null);
  const numberStreet = useRef(null);
  const postalCode = useRef(null);
  const apartment = useRef(null);
  const floor = useRef(null);
  const SocioEconomicLevelRef = useRef(null);
  const locationHumanRef = useRef(null);
  const provinceHumanRef = useRef(null);
  //Información Economica Persona Humana
  const IncomeOfHumanPersonRef = useRef(null);
  const totalIndebtednessOfTheFinancialSystemRef = useRef(null);
  const totalMonthlyCommitmentOfTheFinancialSystemRef = useRef(null);
  const currentSituationWithBCRARef = useRef(null);
  //Información Empleador Persona Humana
  const employerRef = useRef(null);
  const employerDomicileRef = useRef(null);
  const activityBeingCarriedOutRef = useRef(null);
  const workActivityRef = useRef(null);
  const activitySenorityhuman = useRef(null);
  //Relación con la Mutual Persona Humana
  const relationHumanRef = useRef(null);
  const creditDateHumanRef = useRef(null);
  const creditAmountHumanRef = useRef(null);
  const typeOfCreditHumanRef = useRef(null);
  const installmentAmountHumanRef = useRef(null);
  const loanBankHumanRef = useRef(null);
  const amountOfFeesHumanRef = useRef(null);
  const affiliateHumanRef = useRef(null);
  const creditHumanRef = useRef(null);
  //Información PEP Persona Humana
  const politicalExposedHumanRef = useRef(null);
  /*-------------------------*/
  //Persona Jurídica
  const companyNameRef = useRef(null);
  const nacionalityRef = useRef(null);
  const cuitRef = useRef(null);
  const ageRef = useRef(null);
  const phoneRef = useRef(null);
  const emailRef = useRef(null);
  const streetRef = useRef(null);
  const numberStreetRef = useRef(null);
  const locationRef = useRef(null);
  const provinceRef = useRef(null);
  const postalCodeRef = useRef(null);
  const apartmentRef = useRef(null);
  const floorRef = useRef(null);
  const codeOfWorkActivityRef = useRef(null);
  const ActivityBeingCarriedOutRef = useRef(null);
  //Información Economica Persona Jurídica
  const IncomeOfLegalPersonRef = useRef(null);
  const total_indebtedness_of_the_financial_systemRef = useRef(null);
  const total_monthly_commitment_of_the_financial_systemRef = useRef(null);
  const current_status_with_BCRARef = useRef(null);
  //Relación con la mutual Persona Jurídica
  const relationRef = useRef(null);
  //Información PEP Persona Jurídica
  const politicalExposedRef = useRef(null);

  const formattedCurrentDate = moment().format("YYYY-MM-DD");

  // Función para manejar el envío
  const handleSubmitHuman = (e) => {
    const getRelationshipWithMutual = () => {
      const relationHuman = relationHumanRef.current.value;
      const typeOfCredit =
        relationHuman === "Socio"
          ? "Crédito de consumo"
          : relationHuman === "Proveedor"
          ? "Servicio"
          : "Inversión";
      if (relationHuman === "Socio") {
        return {
          relation: relationHumanRef.current.value,
          canal: data.state.data.RelationshipWithMutual.canal,
          creditDate: creditDateHumanRef.current.value,
          amountOfCredit: creditAmountHumanRef.current.value,
          typeOfCredit: typeOfCredit,
          installmentAmount: installmentAmountHumanRef.current.value,
          amountOfFees: amountOfFeesHumanRef.current.value,
          loanBank: loanBankHumanRef.current.value,
          affiliate: affiliateHumanRef.current.value,
          credit: creditHumanRef.current.value,
        };
      } else {
        return {
          relation: relationHumanRef.current.value,
          canal: data.state.data.RelationshipWithMutual.canal,
        };
      }
    };

    const userData = {
      dni: dniRef.current.value,
      user: {
        name: nameRef.current.value,
        lastName: lastNameRef.current.value,
        documentType: documentTypeRef.current.value,
        civilStatus: civilStatusRef.current.value,
        nationality: nationalityRef.current.value,
        dni: dniRef.current.value,
        cuil: cuilRef.current.value,
        dateOfBirth: dateOfBirthRef.current.value,
        placeOfBirth: placeOfBirthRef.current.value,
        phone: phoneHumanRef.current.value,
        email: emailHumanRef.current.value,
        street: street.current.value,
        numberStreet: numberStreet.current.value,
        postalCode: postalCode.current.value,
        apartment: apartment.current.value,
        floor: floor.current.value,
        SocioEconomicLevel: SocioEconomicLevelRef.current.value,
        location: locationHumanRef.current.value,
        province: provinceHumanRef.current.value,
        typeCustomer: "Persona Humana",
        EconomicInformation: {
          IncomeOfHumanPerson: IncomeOfHumanPersonRef.current.value,
          total_indebtedness_of_the_financial_system:
            totalIndebtednessOfTheFinancialSystemRef.current.value,
          total_monthly_commitment_of_the_financial_system:
            totalMonthlyCommitmentOfTheFinancialSystemRef.current.value,
          current_status_with_BCRA: currentSituationWithBCRARef.current.value,
        },
        EmployerInformation: {
          employer: employerRef.current.value,
          employerDomicile: employerDomicileRef.current.value,
          ActivityBeingCarriedOut: activityBeingCarriedOutRef.current.value,
          WorkActivity: workActivityRef.current.value,
          activitySeniority: activitySenorityhuman.current.value,
          activitySeniorityUnit: "years",
        },
        RelationshipWithMutual: getRelationshipWithMutual(),
        UserUpdate: {
          updateAt: formattedCurrentDate,
        },
        PoliticalInformation: {
          politicallyExposed: politicalExposedHumanRef.current.value,
        },
      },
    };
    userUpdate(userData);
  };

  const userUpdate = async (userData) => {
    setLoaderTrueFalse(true);
    setShowButton(false);
    try {
      const res = await axios.post(
        process.env.REACT_APP_UPDATE_HAND_USER_API,
        userData
      );

      if (res.status === 200) {
        setLoaderTrueFalse(false);
        //si no hay probblemas da una aviso que se guardaron los datos
        Swal.fire({
          icon: "success",
          title: "Exito",
          text: "La Persona Humana se actualizo correctamente",
        });
        // una vez que se guardo el usuario se envia nuevamente al inicio
        navigate("/inicio");
      } else {
        setLoaderTrueFalse(false);
        //en caso de problema da un aviso de que hubo un error
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Parece que hubo un error al Actualizar a la Persona Humana",
        });
      }
    } catch (error) {
      setLoaderTrueFalse(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Parece que hubo un error",
      });
    }
  };

  const handleSubmitPersonLegal = () => {
    const relation = relationRef.current.value;
    const typeOfCredit = relation === "Proveedor" ? "Servicio" : "Inversión";
    // Recolectar datos de los componentes hijos
    const companyData = {
      cuit: cuitRef.current.value,
      company: {
        companyName: companyNameRef.current.value,
        nacionality: nacionalityRef.current.value,
        cuit: cuitRef.current.value,
        age: ageRef.current.value,
        ageUnit: "years",
        phone: phoneRef.current.value,
        email: emailRef.current.value,
        documentType: "Cuit",
        status: "Alta",
        street: streetRef.current.value,
        numberStreet: numberStreetRef.current.value,
        location: locationRef.current.value,
        province: provinceRef.current.value,
        postalCode: postalCodeRef.current.value,
        apartment: apartmentRef.current.value,
        floor: floorRef.current.value,
        codeOfWorkActivity: codeOfWorkActivityRef.current.value,
        ActivityBeingCarriedOut: ActivityBeingCarriedOutRef.current.value,
        typeCustomer: "Persona Jurídica",
        EconomicInformationCompany: {
          IncomeOfLegalPerson: IncomeOfLegalPersonRef.current.value,
          total_indebtedness_of_the_financial_system:
            total_indebtedness_of_the_financial_systemRef.current.value,
          total_monthly_commitment_of_the_financial_system:
            total_monthly_commitment_of_the_financial_systemRef.current.value,
          current_status_with_BCRA: current_status_with_BCRARef.current.value,
        },
        RelationshipWithMutualCompany: {
          relation: relation,
          typeOfCredit: typeOfCredit,
          canal: data.state.data.RelationshipWithMutualCompany.canal,
        },
        CompanyUpdate: {
          updateAt: formattedCurrentDate,
        },
        PoliticalInformationCompany: {
          politicallyExposed: politicalExposedRef.current.value,
        },
      },
    };
    companyUpdate(companyData);
  };

  const companyUpdate = async (companyData) => {
    setLoaderTrueFalse(true);
    setShowButton(false);
    try {
      const res = await axios.post(
        process.env.REACT_APP_UPDATE_HAND_COMPANY_API,
        companyData
      );
      if (res.status === 200) {
        //si no hay probblemas da una aviso que se guardaron los datos
        Swal.fire({
          icon: "success",
          title: "Exito",
          text: "La Persona Jurídica se actualizo correctamente",
        });
        setLoaderTrueFalse(false);
        // una vez que se guardo el usuario se envia nuevamente al inicio
        navigate("/inicio");
      } else {
        //en caso de problema da un aviso de que hubo un error
        setLoaderTrueFalse(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Parece que hubo un error al Actualizar a la Persona Jurídica",
        });
      }
    } catch (error) {
      setLoaderTrueFalse(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Parece que hubo un error",
      });
    }
  };

  return (
    <div className="all">
      <HeaderLogoIcon />
      <div className="formupdate">
        {LoaderTrueFalse === true ? <UpdateLoader /> : null}
        {data.state.data.typeCustomer === "Persona Humana" ? (
          <>
            <UpdatepersonalInformation
              data={data}
              refName={nameRef}
              refLastName={lastNameRef}
              refDocumentType={documentTypeRef}
              refCivilStatus={civilStatusRef}
              refNationality={nationalityRef}
              refDni={dniRef}
              refCuil={cuilRef}
              refDateOfBirth={dateOfBirthRef}
              refPlaceOfBirth={placeOfBirthRef}
              refPhone={phoneHumanRef}
              refEmail={emailHumanRef}
              refStreet={street}
              refNumberStreet={numberStreet}
              refPostalCode={postalCode}
              refApartment={apartment}
              refFloor={floor}
              refSocioEconomicLevel={SocioEconomicLevelRef}
              refLocation={locationHumanRef}
              refProvince={provinceHumanRef}
            />
            <UpdateeconomicInformation
              data={data}
              refIncomeOfHumanPerson={IncomeOfHumanPersonRef}
              refTotal_indebtedness_of_the_financial_systemHuman={
                totalIndebtednessOfTheFinancialSystemRef
              }
              refTotal_monthly_commitment_of_the_financial_systemHuman={
                totalMonthlyCommitmentOfTheFinancialSystemRef
              }
              refCurrent_status_with_BCRAHuman={currentSituationWithBCRARef}
            />
            <UpdateemployerInformation
              data={data}
              refEmployerHuman={employerRef}
              refEmployerDomicileHuman={employerDomicileRef}
              refActivityBeingCarriedOutHuman={activityBeingCarriedOutRef}
              refWorkActivityHuman={workActivityRef}
              refactivitySeniority={activitySenorityhuman}
            />
            <UpdaterelationshipWithMutual
              data={data}
              refRelationHuman={relationHumanRef}
              refCreditDateHuman={creditDateHumanRef}
              refCreditAmountHuman={creditAmountHumanRef}
              refTypeOfCreditHuman={typeOfCreditHumanRef}
              refInstallmentAmountHuman={installmentAmountHumanRef}
              refLoanBankHuman={loanBankHumanRef}
              refAmountOfFeesHuman={amountOfFeesHumanRef}
              refAffiliateHuman={affiliateHumanRef}
              refCreditHuman={creditHumanRef}
            />
            <UpdatepoliticAndTerroris
              data={data}
              refPoliticalExposedHuman={politicalExposedHumanRef}
            />
            <div className="boxbuttonupdate">
              {showButton && (
                <button
                className="buttonupdate-amebo"
                onClick={handleSubmitHuman}
              >
                Actualizar
              </button>
              )}
            </div>
          </>
        ) : (
          <>
            <CompanyInformation
              data={data}
              refCompanyName={companyNameRef}
              refNacionality={nacionalityRef}
              refCuit={cuitRef}
              refAge={ageRef}
              refPhone={phoneRef}
              refEmail={emailRef}
              refStreet={streetRef}
              refNumberStreet={numberStreetRef}
              refLocation={locationRef}
              refProvince={provinceRef}
              refPostalCode={postalCodeRef}
              refApartment={apartmentRef}
              refFloor={floorRef}
              refCodeOfWorkActivity={codeOfWorkActivityRef}
              refActivityBeingCarriedOut={ActivityBeingCarriedOutRef}
            />
            <CompanyEconomicInformation
              data={data}
              refIncomeOfLegalPerson={IncomeOfLegalPersonRef}
              refTotal_indebtedness_of_the_financial_system={
                total_indebtedness_of_the_financial_systemRef
              }
              refTotal_monthly_commitment_of_the_financial_system={
                total_monthly_commitment_of_the_financial_systemRef
              }
              refCurrent_status_with_BCRA={current_status_with_BCRARef}
            />
            <CompanyRelationMutual data={data} refRelation={relationRef} />
            <CompanyTerrorism
              data={data}
              refPoliticalExposed={politicalExposedRef}
            />
            <div className="boxbuttonupdate">
              {showButton && (
                <button
                className="buttonupdate"
                onClick={handleSubmitPersonLegal}
              >
                Actualizar
              </button>
              )}      
            </div>
          </>
        )}
      </div>
      <FooterHomePage />
    </div>
  );
};

export default FormUpdateManual;
